import React from 'react';
import { motion } from 'framer-motion';

const ValueStack = () => {
  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-yellow-900/30 to-orange-900/30 border-2 border-yellow-400/50 rounded-3xl p-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
              TOTAL VALUE BREAKDOWN
            </h2>
            
            <div className="space-y-4 mb-8">
              <div className="flex justify-between items-center text-xl border-b border-gray-600 pb-2">
                <span className="text-gray-300">4-Day Live Workshop:</span>
                <span className="text-yellow-400 font-bold">₹68,996</span>
              </div>
              <div className="flex justify-between items-center text-xl border-b border-gray-600 pb-2">
                <span className="text-gray-300">FREE AI Apps Bonus:</span>
                <span className="text-yellow-400 font-bold">₹9,999</span>
              </div>
              <div className="flex justify-between items-center text-xl border-b border-gray-600 pb-2">
                <span className="text-gray-300">Growth Workbook Bonus:</span>
                <span className="text-yellow-400 font-bold">₹7,999</span>
              </div>
            </div>
            
            <div className="border-t-2 border-yellow-400 pt-6">
              <div className="flex justify-between items-center text-2xl md:text-3xl font-bold mb-4">
                <span className="text-white">Total Workshop Value:</span>
                <span className="text-yellow-400">₹86,995</span>
              </div>
              
              <div className="bg-gradient-to-r from-green-600 to-emerald-600 rounded-2xl p-6 mb-6">
                <div className="flex justify-between items-center text-3xl md:text-4xl font-bold">
                  <span className="text-white">Your Investment Today:</span>
                  <span className="text-white">₹0 (FREE)</span>
                </div>
              </div>
              
              <p className="text-green-400 text-xl font-semibold">
                You SAVE ₹86,995 Today!
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ValueStack;